import './App.css';
import MinerView from "./Components/Miner/MinerView";

function App() {
  return (
    <div className="App">
        <MinerView />
    </div>
  );
}

export default App;
